import formatClearSvg from '@listening/assets/astro/images/format-clear.svg';
import speakLineSvg from '@listening/assets/astro/images/speak-line.svg';
import vector7Svg from '@listening/assets/astro/images/Vector-7.svg';
import voiceLivWebp from '@listening/assets/astro/images/voice-avatars/voice-liv.webp';
import voiceScarlettWebp from '@listening/assets/astro/images/voice-avatars/voice-scarlett.webp';
import voiceWillWebp from '@listening/assets/astro/images/voice-avatars/voice-will.webp';
import voiceprintLineSvg from '@listening/assets/astro/images/voiceprint-line.svg';

import { VoiceSample } from '@/components/astro/features/voice-sample';

export function VoiceDemoSection() {
  return (
    <section className='flex items-center justify-center gap-18 px-5 py-8 sm:p-18 lg:gap-14'>
      <div className='flex max-w-[1296px] flex-col items-center justify-center gap-8 sm:gap-14 lg:flex-row lg:gap-18'>
        <div className='relative flex max-w-[31.5rem] flex-1 flex-col items-stretch justify-start gap-4 rounded-[3rem] bg-azure-175 p-5 sm:gap-6 sm:p-8 lg:gap-8 lg:p-14'>
          <VoiceSample
            audioSrc='https://webflow-cdn.listening.com/voice-samples/will-2.mp3'
            imgSrc={voiceWillWebp}
            label='Computer Science'
          />
          <VoiceSample
            audioSrc='https://webflow-cdn.listening.com/voice-samples/liv-3.mp3'
            imgSrc={voiceLivWebp}
            label='Biology'
          />
          <VoiceSample
            audioSrc='https://webflow-cdn.listening.com/voice-samples/scarlett_physics.mp3'
            imgSrc={voiceScarlettWebp}
            label='Physics'
          />
          <div className='relative mt-[20px] flex items-center justify-center self-center'>
            <div className='text-center text-[24px] leading-[36px] font-[600] text-white'>
              Try me
            </div>
            <img
              alt='Arrow'
              className='absolute top-[-13px] right-[-88px] rotate-[-7deg]'
              loading='lazy'
              src={vector7Svg}
            />
          </div>
        </div>
        <div className='flex flex-1 flex-col items-start gap-8'>
          <h2 className='text-[32px] leading-[34px] font-[700] text-neutral-945 sm:text-[40px] sm:leading-[43px] lg:text-[44px] lg:leading-[47px]'>
            “I can’t believe it-she <br />
            <span className='text-azure-595'>sounds like</span> a real person!
          </h2>
          <div className='text-[16px] leading-[24px] text-neutral-945 sm:text-[24px] sm:leading-[36px] lg:text-[20px] lg:leading-[30px]'>
            We use the latest A.I. breakthroughs to create human-like voices.
            They’re easy to listen to and understand, just like an audiobook!
          </div>
          <div className='flex flex-[2_auto] flex-col items-start gap-8 p-0 lg:gap-8 lg:self-auto lg:p-0'>
            <div className='flex items-start gap-4'>
              <img alt='Voiceprint' loading='lazy' src={voiceprintLineSvg} />
              <div className='text-[16px] leading-[21px] font-[400] text-neutral-700 sm:text-[18px] sm:leading-[24px]'>
                Skip directly to the section you care about (abstract, results,
                methods, etc)
              </div>
            </div>
            <div className='flex items-start gap-4'>
              <img alt='Speak' loading='lazy' src={speakLineSvg} />
              <div className='text-[16px] leading-[21px] font-[400] text-neutral-700 sm:text-[18px] sm:leading-[24px]'>
                Easily pronounces technical words in any field
              </div>
            </div>
            <div className='flex items-start gap-4'>
              <img alt='Format Clear' loading='lazy' src={formatClearSvg} />
              <div className='text-[16px] leading-[21px] font-[400] text-neutral-700 sm:text-[18px] sm:leading-[24px]'>
                Remove excess text, like references citations, and computer code
                from the audio
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
